export default "__VITE_ASSET__Ctr_mmWB__"